import { Carousel, CarouselItem } from "element-ui";
import Notifications from "@/components/NotificationPlugin";
import { DropDown } from "../components";
/**
 * You can register global components here and use them as a plugin in your main Vue instance
 */

const GlobalComponents = {
  install(Vue) {
    Vue.component("drop-down", DropDown);
    Vue.use(Carousel);
    Vue.use(CarouselItem);
    Vue.use(Notifications);
  }
};

export default GlobalComponents;
